export default {
  text: '#202020',
  primary: 'black',
  secondary: '#b8b08b',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#484848'
}
